<script setup lang="ts">
import { storeToRefs } from 'pinia';
import ListSearchCommon from 'src/components/ListSearchCommon.vue';
import SceneResult from 'src/components/search-results/SceneCard.vue';
import SceneSkeleton from 'src/components/skeleton-loading/SceneSkeleton.vue';
import { useGlobalSearchStore } from 'src/stores';
import { useApi } from 'src/stores/useApis';
import type { SceneCardDataType } from 'src/types/scene.types';
import { onMounted } from 'vue';

const globalSearchStore = useGlobalSearchStore();
const { currentPage } = storeToRefs(globalSearchStore);
const apiStore = useApi();
onMounted(async () => {
    currentPage.value = 1;
    await apiStore.cancelAllRequests();
    await globalSearchStore.clearResult();
});
const computedData = (data: any) => {
    return data as SceneCardDataType;
};
</script>

<template>
    <ListSearchCommon key="item" type="item">
        <template #item="{ data }">
            <SceneResult :data="computedData(data)" />
        </template>
        <template #skeleton-loading>
            <SceneSkeleton />
        </template>
    </ListSearchCommon>
</template>
